<template>
    <div
        id="Container"
        class="widget-container widget-teaser background--card"
    >
        <a
            href="#"
            @click.prevent="closeSelf"
            class="close"
        >
            <svg-rndr svg="close.svg" />
        </a>
        <div class="widget-contents DialogContent">
            <div class="widget-contents__inner DialogContentInner">
                <h1 class="text-center mb-4 heading-larger">
                    <template
                        v-if="paymentStatus === 'SUCCESS'"
                        v-translate
                    >
                        Success!
                    </template>
                    <template
                        v-else
                        v-translate
                    >
                        Failure!
                    </template>
                </h1>

                <div class=" d-flex justify-content-center mb-4">
                    <svg-rndr
                        v-if="paymentStatus == 'SUCCESS'"
                        svg="check-circle-green.svg"
                        :width="170"
                    />
                    <svg-rndr
                        v-else
                        svg="warning.svg"
                        :width="170"
                    />
                </div>
                <div class="form-row justify-content-center mb-4 text-center">
                    <div class="col-md-8">
                        <div v-if="showResponse">
                            <template v-if="paymentStatus == 'SUCCESS'">
                                <h3
                                    class="text-standard"
                                    v-if='payment.subscription.months > 0'
                                    v-translate='{price: payment.price, product: payment.subscription.name, cardNumber: payment.card.number, cardType: payment.card.type, freq: paymentFrequency}'
                                >
                                    The first %{ freq } subscription payment of $%{ price } for %{ product } with %{ cardType } **** %{ cardNumber } was made successfully.
                                </h3>
                                <h3
                                    class="text-standard"
                                    v-else
                                    v-translate='{price: payment.price, product: payment.subscription.name, cardNumber: payment.card.number, cardType: payment.card.type, freq: paymentFrequency}'
                                >
                                    A payment of $%{ price } for %{ product } with %{ cardType } **** %{ cardNumber } was made successfully.
                                </h3>
                                <div class="subscription__success-body mt-5">
                                    <p
                                        class="mt-4"
                                        v-translate="{ learningCenter: learningCenter }"
                                    >
                                        To get the most out of your new tools we suggest you to look at educational videos in our %{ learningCenter }.
                                    </p>
                                    <p
                                        class="mt-4"
                                        v-translate="{ mySubscriptions: mySubscriptions }"
                                    >
                                        You can always manage your subscription under %{ mySubscriptions }.
                                    </p>
                                </div>
                            </template>
                            <template v-else>
                                <h3 v-translate>There was a problem processing your payment, please wait a few minutes and try again.</h3>
                                <div class="form-group form-row justify-content-center mt-4 mb-0">
                                    <div class="col-md-3 text-center">
                                        <a
                                            class="link d-block mt-3"
                                            href="#"
                                            @click.prevent="closeSelf"
                                            v-translate
                                        >Cancel</a>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <div
                            v-else
                            class="loader loader--only"
                        >
                            <loader />
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-md-8">
                        <flash-message></flash-message>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import widgetMixin from '@M/widgets/dialog';
import { paymentFrequencyForPurchaseOption } from '@H/enrolment';

export default {
    name: 'UpgradeSubscriptionResponse',
    data() {
        return {
            showResponse: false
        }
    },
    mounted() {
        this.loadPaymentConfirmation()
            .then(payment => {
                this.showResponse = true;
                this.reloadUser();
            })
            .catch(err => {
                this.showResponse = true;
                this.reloadUser();
            });

        if (this.paymentStatus == 'SUCCESS') {
            this.sendConfirmationEmail();
        }
    },
    methods: {
        ...mapActions({
            loadPaymentConfirmation: 'Widget/loadPaymentConfirmation',
            sendConfirmationEmail: 'Widget/sendConfirmationEmail'
        }),
    },
    computed: {
        ...mapState('Widget', ['payment', 'paymentStatus']),
        paymentFrequency() {
            return paymentFrequencyForPurchaseOption(this.payment.subscription.months);
        },
        learningCenter() {
            return `${this.$gettext('Learning centre')}`;
        },
        mySubscriptions() {
            return `${this.$gettext('My Subscriptions')}`;
        }
    },
    mixins: [widgetMixin]
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/stages/Widgets/UpgradeSubscriptionResponse.vue